/* Trappbutiken – autosparat UTKAST för konfiguratorerna (Wubs, 2026-09-29).
 *
 * Liam: "vore nice om konfig sparades, så man kan typ stänga, gå ur, och få frågan,
 * Vill du fortsätta konfigurera."
 *
 * Bakgrund: "Ändra" från korgen och önskelistan fanns redan (wubs-konfig-lank.js, 2026-09-24).
 * Det som saknades var en PÅBÖRJAD konfiguration – den som varken lagts i korgen eller sparats.
 * Den försvann när fliken stängdes.
 *
 * ⚠️⚠️ UTKASTET ÅTERSTÄLLS GENOM EN OMLADDNING TILL `?k=…`, inte genom att applicera state
 * i den öppna sidan. Skälet: varje konfigurator har en ÖMTÅLIG startordning (vad som måste
 * ligga i state före renderingen och vad som måste sättas efter – se docs/konfig-gemensamt.md).
 * Den ordningen är redan byggd och verifierad för länkflödet. Att bygga en andra väg in i
 * samma state hade varit ett nytt ställe att göra samma fel på. Utkastet ÄR alltså en länk.
 *
 * ⚠️ Därför bär utkastet exakt samma nyttolast som en delningslänk: BARA VAL, aldrig priser
 * och aldrig titlar. Ett utkast från förra veckan visar dagens pris.
 *
 * Lagring i två lager:
 *   1. localStorage – alla besökare, ingen inloggning, ingen backend.
 *   2. kundmetafält via App Proxy (/apps/wishlist/utkast) när kunden är inloggad, så att
 *      utkastet följer med från telefonen till datorn. Nyast vinner (`tid`).
 * ⚠️ Lager 2 får ALDRIG blockera lager 1: nätet kan vara nere, kunden kan vara utloggad,
 * workern kan svara långsamt. Allt runt fetch är därför tyst och utan await i sparvägen.
 */
(function () {
  'use strict';

  var NYCKEL = 'wubs:konfig-utkast:';
  var PROXY = '/apps/wishlist/utkast';
  var TTL_MS = 30 * 24 * 3600 * 1000;   // en månad – längre än så är valen ändå inaktuella
  var SPAR_DROJ = 700;                  // lokal sparning: en paus i skrivandet
  var SYNK_DROJ = 3000;                 // fjärrsynk: glesare, ett Admin API-anrop per gång

  var kopplade = {};

  /* ---------- lagring ---------- */

  function lasLokalt(typ) {
    try {
      var rå = window.localStorage.getItem(NYCKEL + typ);
      if (!rå) return null;
      var u = JSON.parse(rå);
      return giltigt(u) ? u : null;
    } catch (e) {
      /* privat läge, blockerade kakor, full kvot – utkast är en bonus, aldrig ett krav */
      return null;
    }
  }

  function skrivLokalt(typ, utkast) {
    try {
      if (utkast) window.localStorage.setItem(NYCKEL + typ, JSON.stringify(utkast));
      else window.localStorage.removeItem(NYCKEL + typ);
    } catch (e) {}
  }

  function giltigt(u) {
    if (!u || typeof u !== 'object' || !u.k) return false;
    if (!u.tid || (Date.now() - u.tid) > TTL_MS) return false;
    return true;
  }

  /* Fjärrlagret. Svarar alltid – ett fel blir `null`, aldrig ett kastat undantag. */
  function hamtaFjarr() {
    try {
      return fetch(PROXY, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    } catch (e) {
      return Promise.resolve(null);
    }
  }

  function skickaFjarr(typ, utkast, beacon) {
    var kropp = JSON.stringify({ typ: typ, utkast: utkast });
    try {
      if (beacon && navigator.sendBeacon) {
        /* pagehide: fetch hinner inte alltid iväg, sendBeacon är byggd för just detta.
           App Proxy-signaturen sätts av Shopify på vägen, så beacon duger. */
        navigator.sendBeacon(PROXY, new Blob([kropp], { type: 'application/json' }));
        return;
      }
      fetch(PROXY, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: kropp
      }).catch(function () {});
    } catch (e) {}
  }

  /* ---------- kortet ---------- */

  function kort(k, utkast) {
    /* POPUP sedan 2026-10-29 (Liam: "Vill du fortsätta delen, gör som en popup istället?"). Som kort överst
       i stegkolumnen låg frågan mellan intron och första steget och tryckte ned valen – nu är det en dialog
       över sidan: mörk bakgrund, rutan i mitten. Klick utanför / Escape stänger UTAN att rensa utkastet
       (kunden har inte svarat); "Börja om" rensar som förut. */
    var modal = document.createElement('div');
    modal.className = 'wubs-utkast-modal';
    modal.setAttribute('data-utkast-typ', k.typ);
    var ruta = document.createElement('div');
    ruta.className = 'wubs-utkast';
    ruta.setAttribute('role', 'dialog');
    ruta.setAttribute('aria-modal', 'true');
    ruta.setAttribute('aria-labelledby', 'wubs-utkast-titel-' + k.typ);
    modal.appendChild(ruta);

    /* Tidigare stod "du var på steg 5" här. Det beskrev en destination vi inte längre reser
       till – nu landar Fortsätt alltid på steg 1 – och hade läst som ett fel. Kvar står det
       som faktiskt identifierar utkastet: kundens egna val. */
    var text = utkast.etikett ? String(utkast.etikett) : '';

    ruta.innerHTML =
      '<div class="wubs-utkast__body">' +
        '<strong class="wubs-utkast__titel" id="wubs-utkast-titel-' + k.typ + '">Vill du fortsätta konfigurera?</strong>' +
        (text ? '<span class="wubs-utkast__text"></span>' : '') +
      '</div>' +
      '<div class="wubs-utkast__knappar">' +
        '<button type="button" class="wubs-btn" data-utkast-fortsatt>Fortsätt</button>' +
        '<button type="button" class="wubs-btn wubs-ghost" data-utkast-borja>Börja om</button>' +
      '</div>';

    /* Etiketten kommer ur kundens egna val (träslag, mått) – aldrig innerHTML. */
    var textEl = ruta.querySelector('.wubs-utkast__text');
    if (textEl) textEl.textContent = text;

    ruta.querySelector('[data-utkast-fortsatt]').addEventListener('click', function () {
      var LANK = window.WubsKonfigLank;
      var data = LANK ? LANK.avkoda(utkast.k) : null;
      if (!data) { stang(k, ruta, true); return; }
      /* Landar på STEG 1 (Liam 2026-10-02: "Klickar man fortsätt, så hamnar man på sista
         steget. hamna på första är bättre"). Valen ligger kvar – länken bär dem – men kunden
         går igenom konfigurationen från början och ser vad som är valt i varje steg.
         ⚠️ Sista argumentet är det som gör det. Att bara sluta skicka `?steg=N` räckte INTE:
            varje konfigurator hoppar själv till sista steget så fort `?k=` finns, för "Ändra"
            från korgen vill just det. `start=1` skiljer utkastet från ett färdigt ändringsflöde. */
      var u = LANK.url(data, utkast.ers || '', window.location.origin + window.location.pathname, true);
      window.location.href = u;
    });

    ruta.querySelector('[data-utkast-borja]').addEventListener('click', function () {
      stang(k, ruta, true);
    });
    modal.addEventListener('click', function (e) { if (e.target === modal) stang(k, ruta, false); });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); stang(k, ruta, false); return; }
      if (e.key !== 'Tab') return;                       // fokusen stannar i dialogen
      var b = ruta.querySelectorAll('button');
      var forsta = b[0], sista = b[b.length - 1];
      if (e.shiftKey && document.activeElement === forsta) { e.preventDefault(); sista.focus(); }
      else if (!e.shiftKey && document.activeElement === sista) { e.preventDefault(); forsta.focus(); }
    });

    return modal;
  }

  function stang(k, ruta, rensaOckso) {
    var modal = ruta && ruta.closest ? ruta.closest('.wubs-utkast-modal') : null;
    var bort = modal || ruta;
    if (bort && bort.parentNode) bort.parentNode.removeChild(bort);
    if (rensaOckso) rensa(k.typ);
  }

  function visa(k, utkast) {
    if (!k.rot || !utkast || !utkast.k) return;
    if (document.querySelector('.wubs-utkast-modal[data-utkast-typ="' + k.typ + '"]')) return;
    var modal = kort(k, utkast);
    document.body.appendChild(modal);
    var f = modal.querySelector('[data-utkast-fortsatt]');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }

  /* ---------- publikt ---------- */

  function rensa(typ) {
    /* Stäng också sparandet: annars skrev pagehide tillbaka utkastet efter köpet, och nästa besök
       frågade "Vill du fortsätta?" om det som redan låg i korgen. Ny inmatning slår på det igen. */
    var k = kopplade[typ];
    if (k) { clearTimeout(k.sparTimer); clearTimeout(k.synkTimer); k.interagerat = false; k.sistaKod = ''; k.ers = ''; }
    skrivLokalt(typ, null);
    skickaFjarr(typ, null, false);
  }

  function bygg(k) {
    if (typeof k.serialisera !== 'function') return null;
    var data;
    try { data = k.serialisera(); } catch (e) { return null; }
    var LANK = window.WubsKonfigLank;
    if (!LANK || !data) return null;
    var kod = LANK.koda(data);
    if (!kod) return null;
    var steg = 0;
    try { steg = parseInt(k.steg ? k.steg() : 0, 10) || 0; } catch (e) {}
    var etikett = '';
    try { etikett = k.etikett ? String(k.etikett() || '') : ''; } catch (e) {}
    /* 🧨 `ers` FÖLJER MED (2026-11-03). Korg → Ändra → nytt mått → lämna utan köp → tillbaka → Fortsätt →
       köp gav både gammal och ny rad i korgen: utkastet tappade vilken grupp det skulle ersätta.
       ⚠️ Bara lokalt i praktiken: Workern släpper fältet, och det är rätt. Korgen hör till webbläsaren,
       så ett id från telefonens korg betyder ingenting på datorn. */
    var u = { k: kod, steg: steg, tid: Date.now(), etikett: etikett.slice(0, 160) };
    if (k.ers) u.ers = k.ers;
    return u;
  }

  function spara(k, beacon) {
    /* ⚠️ Inget utkast utan att kunden RÖRT konfiguratorn. Annars hade varje besök på sidan
       sparat startläget, och nästa besök mötts av "vill du fortsätta?" på en tom konfigurator
       – en fråga som inte bara är onödig utan direkt förvirrande. */
    if (!k.interagerat) return;
    var u = bygg(k);
    if (!u) return;
    if (u.k === k.sistaKod && !beacon) return;   // inget nytt att spara
    k.sistaKod = u.k;
    skrivLokalt(k.typ, u);
    if (beacon) { skickaFjarr(k.typ, u, true); return; }
    clearTimeout(k.synkTimer);
    k.synkTimer = setTimeout(function () { skickaFjarr(k.typ, u, false); }, SYNK_DROJ);
  }

  function andrat(typ) {
    var k = kopplade[typ];
    if (!k) return;
    clearTimeout(k.sparTimer);
    k.sparTimer = setTimeout(function () { spara(k, false); }, SPAR_DROJ);
  }

  /* opts: {typ, rot, serialisera, steg, etikett}
     `gaTillSteg` tas fortfarande emot av de tre konfiguratorerna men används INTE härifrån –
     Fortsätt landar alltid på steg 1. Kroken får ligga kvar: vill Tom någon gång ha
     "fortsätt där du var" som ett val är det den vägen in. */
  function koppla(opts) {
    if (!opts || !opts.typ || !opts.rot) return;
    var k = {
      typ: opts.typ,
      rot: opts.rot,
      serialisera: opts.serialisera,
      steg: opts.steg,
      etikett: opts.etikett,
      interagerat: false,
      sistaKod: '',
      ers: '',
      sparTimer: 0,
      synkTimer: 0
    };
    kopplade[k.typ] = k;

    ['pointerdown', 'click', 'input', 'change', 'keydown'].forEach(function (namn) {
      k.rot.addEventListener(namn, function () { k.interagerat = true; }, true);
    });

    window.addEventListener('pagehide', function () {
      clearTimeout(k.sparTimer);
      spara(k, true);
    });

    var q = new URLSearchParams(window.location.search);
    var franLank = !!q.get((window.WubsKonfigLank && window.WubsKonfigLank.PARAM) || 'k');
    k.ers = franLank ? String(q.get((window.WubsKonfigLank && window.WubsKonfigLank.ERS) || 'ers') || '').trim() : '';

    if (franLank) {
      /* Sidan öppnades ur en länk (utkast, korg eller önskelista). Ingen fråga – valen ligger
         redan på plats, och konfiguratorn startar på steg 1.
         ⚠️ Här låg förr ett hopp till `?steg=N`. Ingenting sätter den parametern längre
            (se Fortsätt-knappen ovan). `k.gaTillSteg` finns kvar i konfiguratorerna och
            används av stegnavigeringen – det är bara utkastets hopp som är borta. */
      return;
    }

    /* Ingen länk → erbjud utkastet. Lokalt först (omedelbart), fjärren när den svarar:
       är den nyare byts kortet ut. Kunden ska aldrig vänta på nätet för att se sitt eget. */
    var lokalt = lasLokalt(k.typ);
    if (lokalt) visa(k, lokalt);

    hamtaFjarr().then(function (svar) {
      if (!svar || !svar.loggedIn || !svar.utkast) return;
      var fjarr = svar.utkast[k.typ];
      if (!giltigt(fjarr)) return;
      if (lokalt && lokalt.tid >= fjarr.tid) return;   // det lokala är lika nytt eller nyare
      skrivLokalt(k.typ, fjarr);
      var gammaltKort = document.querySelector('.wubs-utkast-modal[data-utkast-typ="' + k.typ + '"]');
      if (gammaltKort && gammaltKort.parentNode) gammaltKort.parentNode.removeChild(gammaltKort);
      if (!k.interagerat) visa(k, fjarr);             // hann kunden börja om är frågan passé
    });
  }

  window.WubsKonfigUtkast = {
    koppla: koppla,
    andrat: andrat,
    rensa: rensa
  };
})();
